import { toRefs } from 'vue';

/** アイコン種別 */
export const ICON_KEY = {
  HELP: 'help'
};

/** コンテンツ種別 */
export const CONTENTS_KEY = {
  DATA_MONITOR_GRAPH_HELP: 'data-monitor-graph-help'
};

/** アイコン表示位置クラス */
export const POSITION_CLASS = {
  OVER_GRAPH_RIGHT_TOP: 'over-graph-right-top',
};

export default {
  name: 'IconPopover',

  props: {
    iconKey: String,
    contentsKey: String,
    positionClass: String,
    // page内のCSSと干渉するため、デフォルトはbody直下に紐づけて作成する
    container: {
      type: String,
      default: 'body'
    },
    // tooltip表示位置
    placement: {
      type: String,
      default: 'left'
    },
    // tooltip表示トリガー
    trigger: {
      type: String,
      default: 'hover focus'
    },
  },

  setup(props) {
    const { iconKey, contentsKey, positionClass, placement, trigger, container } = toRefs(props);

    return {
      ICON_KEY,
      CONTENTS_KEY,
      iconKey,
      contentsKey,
      positionClass,
      placement,
      trigger,
      container,
    };
  },
};
